import { formatThousandAndUnit, keepTwoOrNullByKey } from '@/utils/utils';
import { V2WaterMapDataCostTrendPostResponse } from '@maxtropy/device-customer-apis-v2';
import * as echarts from 'echarts';
import { isNil } from 'lodash-es';
import { DateTypeByWater } from '../..';
import dayjs from 'dayjs';

export const getChartOption = (data?: V2WaterMapDataCostTrendPostResponse, timeResolution?: DateTypeByWater) => {
  const formatStr = timeResolution === DateTypeByWater.MONTH ? 'MM-DD' : 'M月';
  const totalCostIsAllOverMillion = data?.chartList
    ?.filter(v => v.totalCost != null)
    .every(m => Number(m.totalCost ?? 0) > 10000);

  const areaColors = [
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      { offset: 0, color: '#52E7FF20' },
      { offset: 1, color: '#52E7FF00' },
    ]),
  ];

  return {
    backgroundColor: 'transparent',
    grid: {
      left: 10,
      right: 10,
      top: 30,
      bottom: 10,
      containLabel: true,
    },
    legend: {
      top: 0,
      right: 10,
      icon: 'rect',
      itemWidth: 12,
      itemHeight: 12,
    },
    tooltip: {
      formatter: (items: any) => {
        let { axisValue } = items[0];
        let otherStr = '';
        let str = '';
        // 截断 name，最多 15 个字符
        // let shortName = (name ?? []).length > 12 ? name?.slice(0, 12) + '...' : name;

        items.forEach((item: any) => {
          const { data, marker } = item;
          otherStr += `<div style="width:220px;"><div style="display:flex;justify-content:space-between;align-items:center;"><span>${marker}${axisValue}</span><div>${
            !isNil(data) ? data : '-'
          }${totalCostIsAllOverMillion ? '万' : ''}元</div></div>`;
          str = otherStr;
        });
        return str;
      },
    },

    color: ['#52E7FF'],
    xAxis: [
      {
        type: 'category',
        data: (data?.chartList ?? []).map(a => a.time),
        axisLabel: {
          formatter: function (e: number) {
            return dayjs(e, timeResolution === DateTypeByWater.MONTH ? 'YYYY-MM-DD' : 'YYYY-MM').format(formatStr);
          },
          showMinLabel: true,
          showMaxLabel: true,
          hideOverlap: true,
        },
        boundaryGap: true, // 或直接删掉
      },
    ],
    yAxis: [
      {
        type: 'value',
        name: totalCostIsAllOverMillion ? '万元' : '元',
      },
    ],
    series: [
      {
        type: 'line',
        name: '总成本',
        data: data?.chartList?.map(item =>
          totalCostIsAllOverMillion ? formatThousandAndUnit(item.totalCost).value : keepTwoOrNullByKey(item.totalCost)
        ),
        connectNulls: true,
        smooth: true,
        symbol: 'circle',
        symbolSize: 2,
        itemStyle: {
          // symbol样式
          normal: {
            borderColor: 'rgba(255, 255, 255, 0.2)', // symbol边框颜色
            borderWidth: 6, // symbol边框宽度
          },
        },
        lineStyle: {
          width: 2,
          type: 'solid', //'dotted'点型虚线 'solid'实线 'dashed'线性虚线
        },
        areaStyle: {
          color: areaColors[0],
        },
      },
      {
        type: 'line',
        markLine: {
          silent: true,
          symbol: ['none', 'none'],
          label: {
            formatter: `平均值: ${
              totalCostIsAllOverMillion ? formatThousandAndUnit(data?.avgCost).value : keepTwoOrNullByKey(data?.avgCost)
            }${totalCostIsAllOverMillion ? '万' : ''}元`,
            position: 'insideEndTop',
            color: '#FACC58',
          },
          lineStyle: {
            color: '#FACC58',
            type: 'dashed',
          },
          data: [
            {
              yAxis: totalCostIsAllOverMillion
                ? formatThousandAndUnit(data?.avgCost).value
                : keepTwoOrNullByKey(data?.avgCost),
            },
          ],
        },
      },
    ],
  };
};
